module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/score/score.component.css
// module id = ./src/app/score/score.component.css
// module chunks = main